import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const registerHolder = (id) => request.post(`${API_BASE_URL}/blockchain/register`, { id: id })

export default registerHolder